export default {
  adminControl: '/admin-control',
  alarmArchive: '/alarms/alarm-archive',
  alertGroup: '/alarms/alert-group',
  alertGroupForm: '/alarms/alert-group/form',
  dashboard: '/dashboard',
  detectorsConfiguration:
    '/junction-parameters/configuration/detectors-configuration',
  fixTime: '/time-configuration/multiplan/fix-time',
  clockSetting: '/time-configuration/junction-clock/clock-setting',
  clockSettingConfig: '/time-configuration/junction-clock/clock-setting-config',
  forcePhase: '/synchronization/parameters/force-phase',
  forcePhaseConfig: '/synchronization/parameters/force-phase-config',
  gapTime: '/time-configuration/multiplan/gap-time',
  geographicLocation: '/junction-parameters/geographic-location',
  goGreen: '/synchronization/parameters/go-green',
  goGreenConfig: '/synchronization/parameters/go-green/config',
  greenTime: '/contemporary-status/mode/individual-cycle/green-time',
  greenTimeLedger: '/green-time-ledger',
  greenTimeLedgerPhase: '/green-time-ledger/phase-perspective',
  greenTimeLedgerCycle: '/green-time-ledger/cycle-perspective',
  layoutConfiguration:
    '/junction-parameters/configuration/layout-configuration',
  locationConfiguration:
    '/junction-parameters/configuration/location-configuration',
  junctionSetting: '/junction-setting',
  mapView: '/online/live-operation/geographical-view',
  phaseAggregation: '/contemporary-status/mode/phase-aggregation',
  phaseConfig: '/junction-parameters/specifications/phase-config',
  phaseConfigSpecification:
    '/junction-parameters/specifications/phase-config/config',
  phaseConfiguration: '/junction-parameters/configuration/phase-configuration',
  phaseFlow: '/junction-parameters/specifications/phase-flow',
  phaseDemand: '/junction-parameters/specifications/phase-demand',
  phaseDemandConfig: '/junction-parameters/specifications/phase-demand/config',
  pushButtonConfig: '/junction-parameters/specifications/push-button/config',
  demandLoopConfig: '/junction-parameters/specifications/demand-loop/config',
  maxTime: '/time-configuration/multiplan/max-time',
  minTime: '/time-configuration/multiplan/min-time',
  overseeMode: '/online/live-operation/oversee-mode',
  permissions: '/dashboard/permissions',
  recentAlarm: '/alarms/recent-alarms',
  roles: '/dashboard/roles',
  rtsp: '/online/cctv/rtsp',
  signalOutput: '/junction-parameters/specifications/signal-output',
  signalOutputEdit: '/junction-parameters/specifications/signal-output/config',
  systemInputs: '/junction-parameters/specifications/system-inputs',
  systemInputsConfig:
    '/junction-parameters/specifications/system-inputs/config',
  syncFromJunction: '/junction-parameters/configuration/sync-from-junction',
  systemGeneralSetting:
    '/junction-parameters/junction-control/system-general-setting',
  countdownMode: '/junction-parameters/traffic-timer/count-down-assignment',
  countdownModeSetting:
    '/junction-parameters/traffic-timer/count-down-assignment/settings',
  xaitsLinkPair: '/junction-parameters/junction-pairing/xaits-link-pairing',
  xaitsLinkPairConfig:
    '/junction-parameters/junction-pairing/xaits-link-pairing-config',
  countdownSetting: '/junction-parameters/traffic-timer/count-down-setting',
  faultMonitoring: '/junction-parameters/junction-control/fault-monitoring',
  generalTimeParameters:
    '/junction-parameters/junction-control/general-time-parameters',
  nightFlashing: '/junction-parameters/junction-control/night-flashing',
  streetLight: '/junction-parameters/junction-control/street-light',
  advanceControlSetting:
    '/junction-parameters/junction-control/advance-control-setting',
  updateToJunction: '/junction-parameters/configuration/update-to-junction',
  timeWindows: '/synchronization/parameters/time-windows',
  trafficMagnitude:
    '/contemporary-status/mode/individual-cycle/traffic-magnitude',
  transmitForcingSignal: '/synchronization/parameters/transmit-forcing-signal',
  transmitLockingSignal: '/synchronization/parameters/transmit-locking-signal',
  transmitLockingSignalConfig:
    '/synchronization/parameters/transmit-locking-signal/config',
  transmitForcingSignalConfig:
    '/synchronization/parameters/transmit-forcing-signal/config',
  vaTime: '/time-configuration/va-time',
  vehicleVolumeLedgerPhase: '/vehicle-volume-ledger/phase-perspective',
  vehicleVolumeLedgerCycle: '/vehicle-volume-ledger/cycle-perspective',
  waitingTime: '/contemporary-status/mode/individual-cycle/waiting-time',
}
